export default "__VITE_ASSET__f464abe0__"